import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-sub-header',
  imports: [TranslateModule],
  templateUrl: './sub-header.component.html',
  styleUrl: './sub-header.component.css',
})
export class SubHeaderComponent implements OnInit {
  title = '';

  constructor(
    private router: Router,
    private translate: TranslateService,
    private logger: NGXLogger
  ) { }

  ngOnInit() {
    this.setTitle(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setTitle(event.url);
      });
  }

  setTitle(ruta: string) {

    const key = ruta?.split('/').at(-1) || '';
    const translationKey = key ? key.toLocaleUpperCase() : 'DEFAULT';

    // this.logger.info(translationKey);

    this.translate.get(translationKey).subscribe({
      next: (res: string) => {
        this.title = res && res !== '/' ? res : 'DEFAULT';
      },
      error: (err) => {
        this.logger.error(err);
        this.title = 'DEFAULT';
      }
    });
  }

}
